import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { EndpointResponse } from '@/types/endpoints';
import type { CreateOrderPayload } from '@/types/order-create';
import { utils } from '@/utils';
import type { WriteRequestOptions } from '../requestOptions';

export const postOrder = async (
  scope: RequestScope,
  payload: CreateOrderPayload,
  options: WriteRequestOptions
): Promise<EndpointResponse<unknown>> => {
  try {
    const response = await scopedApi(scope).post<EndpointResponse<unknown>>('order', payload, options);
    return response.data;
  } catch (e) {
    return utils.error.handleAxiosError(e, { redactRequestData: true });
  }
};
